import { injectable, inject } from 'inversify';
import IValidationTokenStorage from './IValidationTokenStorage';
import ThirdPartyTypes from '../../di/ThirdPartyTypes';
import DomainTypes from '../../di/DomainTypes';

const DID_VALIDATION_TOKEN_STORE_KEY = 'did.validation_token';

@injectable()
export default class ValidationTokenStorage implements IValidationTokenStorage {

    @inject(ThirdPartyTypes.SessionStorage)
    private sessionStorage!: Storage;

    @inject(DomainTypes.CorrelationId)
    private correlationId!: String;

    setValidationToken(validationToken: string): void {
        this.sessionStorage.setItem(
            this.getCompositeKey(DID_VALIDATION_TOKEN_STORE_KEY),
            validationToken);
    }
    
    hasValidationToken(): boolean {
        return null !== this.sessionStorage.getItem(
            this.getCompositeKey(DID_VALIDATION_TOKEN_STORE_KEY));
    }

    getValidationToken(){
        return this.sessionStorage.getItem(
            this.getCompositeKey(DID_VALIDATION_TOKEN_STORE_KEY));
    }
    removeValidationToken(){
        this.sessionStorage.removeItem(this.getCompositeKey(DID_VALIDATION_TOKEN_STORE_KEY));
    }

    private getCompositeKey(primaryKey: string) {
        return `${primaryKey}.${this.correlationId}`;
    }
}